import { apiClient } from './client';
import type { Session, TwoFactorStatus } from '@/types';

function mapSession(raw: Record<string, unknown>): Session {
    return {
        id: raw.id as string,
        device: raw.device as string,
        browser: raw.browser as string,
        ip: raw.ip as string,
        lastActive: raw.last_active as string,
        isCurrent: raw.is_current as boolean,
    };
}

export const securityApi = {
    requestPasswordChangeCode() {
        return apiClient.post<void>('account/password/code');
    },

    changePassword(code: string, newPassword: string) {
        return apiClient.post<void>('account/password/change', { code, new_password: newPassword });
    },

    requestAccountDeletionCode() {
        return apiClient.post<void>('account/delete/code');
    },

    confirmAccountDeletion(code: string) {
        return apiClient.post<void>('account/delete/confirm', { code });
    },

    getTwoFactorStatus() {
        return apiClient.get<TwoFactorStatus>('account/2fa');
    },

    enableTwoFactor(code: string) {
        return apiClient.post<void>('account/2fa/enable', { code });
    },

    initTwoFactor() {
        return apiClient.post<TwoFactorStatus>('account/2fa/init');
    },

    disableTwoFactor(password: string) {
        return apiClient.post<void>('account/2fa/disable', { password });
    },

    async getSessions(): Promise<Session[]> {
        const raw = await apiClient.get<Record<string, unknown>[]>('account/sessions');
        return raw.map(mapSession);
    },

    revokeSession(id: string) {
        return apiClient.delete<void>(`account/sessions/${id}`);
    },

    revokeAllSessions() {
        return apiClient.delete<void>('account/sessions');
    },
};
